module.exports = __webpack_public_path__ + "static/CareLabel-v6-8ea04c00e33ce686a86f3b3dd4f890f2.svg";